// Which routes get the app shell, as data rather than as branches inside the
// Layout component — mirroring navConfig.js. Layout's import graph reaches the
// account bar and the whole user API, so a rule this small is not worth
// mounting a component tree to test.

// Routes a signed-out visitor can legitimately be on. They render bare: app
// chrome here would offer authenticated navigation to someone who has no
// session, and /delete-account in particular is reached from a Play Store
// listing by people who cannot sign in at all (#27).
const AUTH_ROUTES = [
  "/login",
  "/signup",
  "/forgot-password",
  "/delete-account",
  // Public policy pages (#65). Linked from the signup consent control and reached
  // by logged-out visitors and Play Store reviewers, so they must render bare.
  "/privacy",
  "/terms",
];

export const isAuthRoute = (pathname) =>
  AUTH_ROUTES.some((r) => pathname.startsWith(r)) ||
  pathname.startsWith("/reset-password") ||
  pathname.startsWith("/verify-email") ||
  pathname.startsWith("/auth/callback") ||
  pathname.startsWith("/oauth/consent");

const FULLSCREEN_ROUTES = ["/map"];

export const isFullscreenRoute = (pathname) =>
  FULLSCREEN_ROUTES.some((r) => pathname.startsWith(r));

// An ACTIVE conversation is an immersive task (#149): it hides the global top
// account bar and the bottom nav so the conversation owns the viewport (header /
// messages / composer / keyboard), and so the chat's own ⋯ menu never collides
// with the global profile/market buttons. The thread LIST (bare /chat) keeps the
// chrome — it is normal navigation.
//
// "Active conversation" is read from the route, not ChatPage's internal state,
// because ChatPage mirrors the open thread into the URL: selecting a thread sets
// ?threadId=…, deep links arrive as ?threadId=/?userId=, and "back to list"
// clears the query. That keeps this a pure, testable route rule and makes
// Android hardware Back (pop the query → back to the list) restore the chrome.
export const isImmersiveChatRoute = (pathname, search = "") => {
  if (!pathname || !pathname.startsWith("/chat")) return false;
  const query = new URLSearchParams(
    typeof search === "string" && search.startsWith("?") ? search.slice(1) : search
  );
  return query.has("threadId") || query.has("userId");
};
